import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const assumeLocalDateIsUtcNoon = (date: Date): Date =>
  dayjs(date).utc(true).hour(12).minute(0).second(0).millisecond(0).toDate()

export default assumeLocalDateIsUtcNoon
